import * as React from 'react';
import Button from '@telia-front/button';
import FileField from '@telia-front/filefield';
import Grid, { GridColumn } from '@telia-front/grid';
import Heading from '@telia-front/heading';
import { Modal, ModalTrigger, ModalProvider } from '@telia-front/modal';
import Notice from '@telia-front/notice';
import Select from '@telia-front/select';
import Text from '@telia-front/text';
import TextArea from '@telia-front/textarea';
import TextAreaRows from '@telia-front/textarea-rows';
export default class TemplateMultismsSending extends React.Component {
    constructor() {
        super(...arguments);
        this.closeModal = () => {
            if (this.props.onClose) {
                this.props.onClose();
            }
        };
        this.openModal = () => {
            if (this.props.onOpen) {
                this.props.onOpen();
            }
        };
    }
    getFileName() {
        return (React.createElement("p", null,
            this.props.uploadedFileLabel,
            ": ",
            React.createElement("strong", null, this.props.uploadedFileName)));
    }
    render() {
        return (React.createElement(Text, null,
            this.props.notice && React.createElement(Notice, Object.assign({}, this.props.notice)),
            React.createElement(Grid, Object.assign({}, (this.props.notice && {
                className: 'text__margin-double',
            })),
                React.createElement(GridColumn, { width: ['md-8'] },
                    React.createElement(Grid, null,
                        React.createElement(GridColumn, { width: ['xs-12'] },
                            React.createElement(TextArea, Object.assign({}, this.props.smsContentTextArea))),
                        React.createElement(GridColumn, { width: ['xs'] },
                            React.createElement("p", { className: "text-small text-light" }, this.props.lettersUsedLabel),
                            React.createElement("p", { className: "text-bold" }, this.props.lettersUsedValue)),
                        React.createElement(GridColumn, { width: ['xs'] },
                            React.createElement("p", { className: "text-small text-light" }, this.props.lettersAvailableLabel),
                            React.createElement("p", { className: "text-bold" }, this.props.lettersAvailableValue)),
                        React.createElement(GridColumn, { width: ['xs'] },
                            React.createElement("p", { className: "text-small text-light" }, this.props.smsCountLabel),
                            React.createElement("p", { className: "text-bold" }, this.props.smsCountValue)))),
                React.createElement(GridColumn, { width: ['md-4'] },
                    React.createElement(Text, null,
                        React.createElement(Select, Object.assign({}, this.props.senderSelect)),
                        React.createElement(TextArea, Object.assign({}, this.props.receiverTextArea)),
                        this.props.hasFileUploaded && this.getFileName(),
                        React.createElement(ModalProvider, { isOpen: this.props.isModalOpen, onClose: this.closeModal, onOpen: this.openModal },
                            React.createElement(ModalTrigger, null,
                                React.createElement(Button, Object.assign({}, this.props.importButton))),
                            React.createElement(Modal, { size: "6-col" },
                                React.createElement(Text, null,
                                    React.createElement(Heading, { element: "h2", className: "h4 text-center" }, this.props.receiverFileTitle),
                                    React.createElement(Grid, null,
                                        React.createElement(GridColumn, { width: ['sm-6'] },
                                            React.createElement(TextAreaRows, Object.assign({}, this.props.receiverFileTextArea))),
                                        React.createElement(GridColumn, { width: ['sm-6'] },
                                            React.createElement(Text, null,
                                                React.createElement(FileField, Object.assign({}, this.props.receiverFileField, { key: this.props.fileFieldKey })),
                                                React.createElement(Grid, { align: ['middle-xs'] },
                                                    React.createElement(GridColumn, { width: ['xs'] },
                                                        React.createElement(Button, Object.assign({}, this.props.receiverFileSubmitButton))),
                                                    React.createElement(GridColumn, { width: ['xs'] },
                                                        React.createElement(Button, Object.assign({}, this.props.receiverFileCancelButton))))))))))))),
            React.createElement(Grid, { className: "text__margin-double", align: ['middle-xs'] },
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement(Button, Object.assign({}, this.props.submitButton))),
                React.createElement(GridColumn, { width: ['xs'] },
                    React.createElement(Button, Object.assign({}, this.props.cancelButton))))));
    }
}
